import Component from 'gia/Component';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

gsap.registerPlugin(ScrollTrigger);


export default class BlueBox extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      texte: {}
    };
  }

  mount() {
    let that = this;
    this.element.addEventListener('mouseenter', function(e) {
      gsap.to(that.ref.texte, {height: 'auto', duration: 0.3});
    })
    this.element.addEventListener('mouseleave', function(e) {
      gsap.to(that.ref.texte, {height: '0', duration: 0.3});
    })
  }


}